import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import CorrectIcon from '@learningblocks/exp-constants/lib/Images/correct-relative.svg';
import IncorrectIcon from '@learningblocks/exp-constants/lib/Images/incorrect-relative.svg';

const MESSGAES = {
  COMPLETE: {
    message: 'You have selected all the correct options.',
    icon: CorrectIcon,
  },
  INCOMPLETE: {
    message: "You haven't selected all the correct options.",
    icon: IncorrectIcon,
  },
};

/**
 *  FeedbackMessage:
 *  - The component gives a feeedback message for Multiple Ansswer questions
 *  - A success message is displayed when all right answers are selected
 *  - A failure message is displayed when there are still correct answers to be selected.
 */
export function FeedbackMessage(props) {
  return (
    <div className={props.className}>
      <Image src={MESSGAES[props.messageType].icon} alt={props.messageType} />
      <span>{MESSGAES[props.messageType].message}</span>
    </div>
  );
}

FeedbackMessage.propTypes = {
  /**
   * The className to be set for the componnet
   */
  className: PropTypes.string.isRequired,
  /**
   * Type of the feedback : ['COMPLETE', 'INCOMPLETE']
   */
  messageType: PropTypes.oneOf(['COMPLETE', 'INCOMPLETE']),
};
